import React from "react";
import LegalLayout from "./LegalLayout";
import { PLANS, TOPUPS, LEGAL_TEXT, FORMULA } from "../config/pricingPolicy";

const planLine = (p) => {
  const parts = [
    `${p.name} ${p.price}${p.priceSuffix}`,
    `${p.credits} credits`,
    p.blocks != null ? `${p.blocks} blocks` : null,
    p.minutes ? `${p.minutes} min` : null,
    p.resolution ? p.resolution : null,
  ].filter(Boolean);
  return parts.join(", ");
};

const sections = [
  [
    "Pricing",
    LEGAL_TEXT,
  ],
  [
    "How credits are calculated",
    `A video is split into ${FORMULA.blockSeconds}-second blocks. Each block costs ${FORMULA.creditsPerBlock} credits. ` +
      `Resolution multipliers: 720p 1.0x, 1080p 1.25x, 4K 1.75x. ` +
      `One credit covers ${FORMULA.creditSeconds} seconds of standard output. Drafting and editing are free; credits are used when you export a finished video.`,
  ],
  [
    "Plans",
    PLANS.map(planLine).join(". "),
  ],
  [
    "Top-ups",
    TOPUPS.map((t) => `${t.credits} credits / ${t.minutes} min — $${t.price}`).join(". "),
  ],
];

export default function PricingPolicyPage() {
  return <LegalLayout title="Pricing Policy" updated="2026-05-11" sections={sections} />;
}
